import { memo } from 'react';
import { Button } from '@heroui/react';
import { TermStudent } from '@/entities/Courses';
import { Svg } from '@/shared/ui/Svg';
import OpenedLockIcon from '@/shared/assets/icons/opened-lock.svg';
import TrashIcon from '@/shared/assets/icons/trash.svg';

interface TermStudentsSelectedActionsProps {
  selectedRows: TermStudent[];
  onRemoveSelected?: () => void;
  onBlockSelected?: () => void;
  onDeleteSelected?: () => void;
  isLoading?: boolean;
}

export const TermStudentsSelectedActions = memo(
  ({ selectedRows, onRemoveSelected, onBlockSelected, onDeleteSelected, isLoading }: TermStudentsSelectedActionsProps) => {
    if (selectedRows.length === 0) {
      return null;
    }

    return (
      <div className="flex items-center gap-4">
        <span className="text-sm text-grey-secondary">Selected: {selectedRows.length}</span>
        {onRemoveSelected && (
          <Button
            variant="light"
            className="text-base font-semibold text-grey-secondary"
            onPress={onRemoveSelected}
          >
            Remove ({selectedRows.length})
          </Button>
        )}
        {onBlockSelected && (
          <Button
            variant="light"
            className="text-base font-semibold"
            onPress={onBlockSelected}
            isLoading={isLoading}
            isDisabled={isLoading}
            startContent={<Svg Icon={OpenedLockIcon} width={16} height={16} />}
          >
            Block selected ({selectedRows.length})
          </Button>
        )}
        {onDeleteSelected && (
          <Button
            variant="light"
            className="text-base font-semibold text-red-tertiary"
            onPress={onDeleteSelected}
            startContent={<Svg Icon={TrashIcon} width={16} height={16} />}
          >
            Delete ({selectedRows.length})
          </Button>
        )}
      </div>
    );
  },
);

TermStudentsSelectedActions.displayName = 'TermStudentsSelectedActions';

